export default {
    //home.js
    "Our Partners": "I nostri partner",

    //AdressInput.js
    "type your address": "inserisci il tuo indirizzo",

    //StoreScreen.js
    "km away": " km ",
    "Closed 🔴": "Chiuso 🔴",
    "Open 🟢": "Aperto 🟢",

    "Days":"Giorni",
    "and":"e",
    "Hours":"Ore",
    "Minutes":"Minuti",
    "Created From :":"Creato da :",
    "Categories :":"Categorie :",


    //DateModel.js
    "Monday": "Lunedì",
    "Tuesday": "Martedì",
    "Wednesday": "Mercoledì",
    "Thursday": "Giovedì",
    "Friday": "Venerdì",
    "Saturday": "Sabato",
    "Sunday": "Domenica",
    "Closed": "Chiuso",
    "Service Hours": "Orari di servizio",
    "Language": "lingua",

    //menu.js
    "Our promos": "Le nostre promozioni",

    //selectoption.js
    "(optional)": "(Opzionale)",
    "Required": "Obbligatorio",
    "select up to": "seleziona fino a",

    //SubmitOrder.js
    "select at least": "seleziona almeno",
    "of": "di",
    "Quantity": "Quantità",
    "change your order": "cambia il tuo ordine",

    //submitOrderPromo.js
    "Finish": "Finitura",
    "Next": "Prossimo",

    //ModelPrincipal.js
    "Email Address": "Indirizzo email",
    "Continue": "Continua",
    "Or": "Oppure",
    "Continue with Google": "Continua con Google",
    "Email does not exist": "L'email non esiste",

    //ModalSignup.js
    "First Name": "Nome",
    "Last Name": "Cognome",
    "Email": "Email",
    "Enter Phone Number": "Inserisci numero di telefono",
    "Password": "Password",
    "Confirm Password": "Conferma password",
    "Passwords do not match": "Le password non corrispondono",
    "Signup": "Registrati",
    "Sign up": "Registrati",
    "Male": "Maschio",
    "Female": "Femmina",
    "All fields are required": "Tutti i campi sono obbligatori",
    "One uppercase": "Una lettera maiuscola",
    "One number": "Un numero",
    "Min 8 characters": "Minimo 8 caratteri",
    "One special character": "Un carattere speciale",

    //ModelLogin.js
    "Login": "Accedi",
    "Sign in": "Accedi",
    "Forget password": "Password dimenticata",
    "Add to cart": "Aggiungi al carrello",
    "kitchen note": "Nota cucina",
    "Leave an addioonal note about your food (not too spicy)": "Lascia una nota aggiuntiva sulla tua cucina (non troppo piccante)",

    //Cart.js
    "Your Order": "Il tuo ordine",
    "Checkout": "Pagamento",
    "tax-exclusive": "Esclusa tassa",
    "ASAP": "il prima possibile",
    "By checking this box, you confirm your order to": "Selezionando questa casella, confermi il tuo ordine a",
    "This action is irreversible and commits to the purchase as outlined.": "Questa azione è irreversibile e impegna all'acquisto come descritto.",
    "Minimum order value": "Valore minimo dell'ordine",
    " for ": " per modalità",
    "is ": "è ",

    //checkout.js
    "Contact": "Contatto",
    "Name": "Nome",
    "Email": "Email",
    "phone number": "numero di telefono",
    "Order in Advance": "Ordina in anticipo",
    "Reset": "Ripristina",
    "Month D, YYYY HH:MM": "Mese G, AAAA HH:MM",
    "Payment Method": "Metodo di pagamento",
    "Cash": "Contante",
    "EPT": "TPE",
    "Credit/Debit Card": "Carta di credito / debito",
    "Place Your Order": "Fai il tuo ordine",
    "Dine-in Fee": "Commissione per mangiare sul posto",
    "Takeaway Fee": "Commissione per asporto",
    "Delivery Fee": "Commissione di consegna",
    "Dine-in fees": "Commissioni per mangiare sul posto",
    "Takeaway fee": "Commissione per asporto",
    "Delivery fee": "Commissione di consegna",
    "Delivery note": "Nota per la consegna",
    "Leave a note for your delivery": "Lascia una nota per la consegna",
    "Your Addresses": "I tuoi indirizzi",
    "Friend": "Amico",
    "Home": "Casa",
    "Work": "Lavoro",
    "Other": "Altro",
    "Note for the delivery man:": "Nota per il fattorino",
    " Ex : Building or entry code": " Es: Edificio o codice d'ingresso",
    "Save": "Salva",

    //modalresetPassword.js
    "Email has been send, check your email!": "E-mail inviata, controlla la tua email!",
    "Resend Email": "Rinvia email",

    //firstPage.js
    "All Stores": "Tutti i ristoranti",
    'Nearby Stores': "Ristoranti nelle vicinanze",

    //ModelEmailSend.js
    "Email has been send, check your email!": "E-mail inviata, controlla la tua email!",
    "Resend Email": "Rinvia email",

    //AllStoresScreen.js
    "All Stores": "Tutti i ristoranti",

    //ModalModes.js
    "Select Your Mode": "Seleziona la tua modalità",
    "Yes": "Sì",
    "No": "No",

    //SelectStore.js
    "Select Store": "Seleziona ristorante",
    "Confirm": "Conferma",
    "Delivery": "Consegna",
    "Takeaway": "Da asporto",
    "Dine-in": "sul posto",

    //ProductModel
    "leave your additional note": "lascia una nota aggiuntiva",
    "Additional note": "Nota aggiuntiva",
    "Garnish":"Guarnire",
    //SubmitOrder.js
    "select at least": "seleziona almeno",
    "of": "di",
    "Quantity": "Quantità",

    //OrdersHistory
    "TIME": "TEMPO",
    "MODE": "MODALITÀ",
    "STATUS": "STATO",
    "PAYMENT": "PAGAMENTO",
    "TOTAL": "TOTALE",
    "VIEW": "VEDI",
    "accepted": "accettato",
    "ready": "pronto",
    "rejected": "rifiutato",
    "missed": "perso",
    "pending": "In attesa",

    //OrderHistoryModal.js
    "(Without service fees)": "(Senza tasse di servizio)",
    "ORDER ID": "ID ORDINE",
    "Total price": "Prezzo totale",
    "Add note": "Aggiungi una nota",
    "Leave your note here": "Lascia la tua nota qui",
    "Order Time": "Tempo dell'ordine",
    "Schedule Order": "Programma ordine",
    "Minutes": "Minuti",
    "Seconds": "Secondi",
    "left.": "restante.",
    "We regret to inform you that your order has been Missed": "Ci dispiace informarti che il tuo ordine è stato perso",
    "We regret to inform you that your order has been Rejected": "Ci dispiace informarti che il tuo ordine è stato rifiutato",
    "We are pleased to inform you that your order has been Accepted": "Siamo lieti di informarti che il tuo ordine è stato accettato",
    "We are pleased to inform you that your order is Ready": "Siamo lieti di informarti che il tuo ordine è pronto",
    "Free": "Gratis",
    "By checking this box, you confirm that you are certain about proceeding with this specific order to": "Selezionando questa casella, confermi di essere sicuro di procedere con questo ordine specifico a",
    "This action is irreversible and commits to the purchase as outlined. Please review your selections carefully before confirming": "Questa azione è irreversibile e impegna all'acquisto come descritto. Rivedi attentamente le tue selezioni prima di confermare",
    "The restaurant is closed, ASAP mode is not available": "Il ristorante è chiuso, la modalità ASAP non è disponibile.",

    "Craving something delicious? Order your favorite meals from our platform and enjoy fast, easy, and reliable food delivery. Discover a wide variety of cuisines, exclusive deals, and hassle-free ordering. Satisfaction guaranteed with every bite.": "Hai voglia di qualcosa di delizioso? Ordina i tuoi piatti preferiti dalla nostra piattaforma e goditi una consegna rapida, facile e affidabile. Scopri una vasta varietà di cucine, offerte esclusive e ordini senza problemi. Soddisfazione garantita ad ogni morso.",
    "Get connected with us on social networks": "Connettiti con noi sui social network",
    "Pick your 1st choice": "Scegli la tua prima scelta",
    "Previous choices": "Scelte precedenti",
    "Now pick your": "Ora scegli il tuo",
    "choice.": "scelta.",
    "th": "°",
    "rd": "°",
    "nd": "°",
    "Chosen size": "Taglia scelta",
    "Cart will be cleared , are you sure": "Il carrello verrà svuotato, sei sicuro?",
    "From ": "da ",
    
    //new
    "Phone Number": "Numero di telefono",
    "Add Phone Number": "Aggiungi numero di telefono",
    "Enter your phone number": "Inserisci il tuo numero di telefono",
    "No payment method selected. Order creation aborted.": "Nessun metodo di pagamento selezionato. Creazione ordine annullata.",
    "Select Time Order": "Seleziona orario ordine",
    "Your order is waiting for the restaurant's approval.": "Il tuo ordine è in attesa di approvazione da parte del ristorante.",
    "Please correct the phone number.": "Correggi il numero di telefono.",
    "Unavailable": "Non disponibile",
    "Switching modes will clear your cart.": "Cambiare modalità svuoterà il tuo carrello.",
    "Would you like to proceed?": "Vuoi procedere?",
    "Enter your Delivery Address": "Inserisci il tuo indirizzo di consegna",
    "Address Type": "Tipo di indirizzo",
    "Continue": "Continua",
    "empty": "vuoto",
    "Coupon not found": "Coupon non trovato",
    "The coupon has expired and is no longer valid": "Il coupon è scaduto e non è più valido",
    "Coupon is valid and active": "Il coupon è valido e attivo",
    "Internal Server Error": "Errore interno del server",
    "Discount coupon": "Coupon sconto",
    "Apply": "Applica",
    "Enter coupon": "Inserisci coupon",
    "Have a coupon?": "Hai un coupon?",
    "The coupon has not started yet and is not valid": "Il coupon non è ancora attivo e non è valido",


    "Table number :":"vide",
"Enter your table number":"vide",
"Your table number is ":"vide",
"empty":"vide",

// Terms Popup 
"By continuing, you accept our":"Continuando, accetti il nostro",
"General Conditions":"Condizioni Generali",
"Privacy Policy":"Privacy Policy",
"Terms of Service":"Termini di servizio",

 "terms.title": "Termini e Condizioni di Vendita",
  "terms.section1.title": "1. Scopo",
  "terms.section1.content": "Questi termini regolano le vendite effettuate sulla piattaforma Eatorder tra venditori partner e acquirenti.",
  "terms.section2.title": "2. Ordini",
  "terms.section2.content": "L'acquirente seleziona un prodotto, effettua un ordine e completa il pagamento. Una conferma viene inviata via email. Il venditore è responsabile della spedizione e consegna.",
  "terms.section3.title": "3. Prezzi",
  "terms.section3.content": "Tutti i prezzi sono espressi in euro, comprensivi di tutte le tasse (IVA). Le spese di spedizione vengono aggiunte durante il checkout.",
  "terms.section4.title": "4. Pagamento",
  "terms.section4.content": "I pagamenti sono elaborati in modo sicuro tramite <strong>Stripe</strong> e/o <strong>PayPal</strong>. Nessuna informazione bancaria viene memorizzata sui nostri server.",
  "terms.section5.title": "5. Consegna",
  "terms.section5.content": "La consegna è gestita dai venditori partner secondo i tempi indicati nelle pagine dei prodotti.",
  "terms.section6.title": "6. Diritto di recesso",
  "terms.section6.content": "Secondo la legge vigente, gli acquirenti hanno 14 giorni di tempo dalla ricezione per recedere dall'acquisto (tranne per i prodotti non rimborsabili).",
  "terms.section7.title": "7. Servizio Clienti",
  "terms.section7.content": "Per qualsiasi domanda o reclamo, contattaci a: support@eatorder.com",
  "terms.section8.title": "8. Responsabilità",
  "terms.section8.content": "Eatorder non è responsabile per le controversie tra acquirenti e venditori. Agiamo solo come piattaforma intermediaria.",
  "terms.section9.title": "9. Legge Applicabile",
  "terms.section9.content": "Questi termini sono regolati dalla legge francese. In caso di controversia, il tribunale competente sarà quello della sede legale di Eatorder.",

   "privacy.title": "Informativa sulla Privacy",
  "privacy.intro": "Ci impegniamo a proteggere la tua privacy. Questa informativa spiega come raccogliamo, utilizziamo, condividiamo e proteggiamo i tuoi dati personali sulla nostra piattaforma Eatorder.",
  "privacy.section1.title": "1. Dati Raccolti",
  "privacy.section1.items": [
    "Informazioni di identificazione: nome completo, indirizzo email, numero di telefono",
    "Dati di pagamento tramite fornitori terzi (es. Stripe, PayPal)",
    "Dati di navigazione: indirizzo IP, cookie, pagine visitate"
  ],
  "privacy.section2.title": "2. Utilizzo dei Dati",
  "privacy.section2.intro": "I tuoi dati vengono utilizzati per:",
  "privacy.section2.items": [
    "Elaborare ordini e gestire le consegne",
    "Gestire il tuo account e le tue preferenze",
    "Inviare notifiche e aggiornamenti (con consenso)",
    "Migliorare le funzionalità e le prestazioni del servizio"
  ],
  "privacy.section2.legal": "<strong>Base legale:</strong> esecuzione del contratto, consenso dell'utente e interesse legittimo.",
  "privacy.section3.title": "3. Condivisione dei Dati",
  "privacy.section3.intro": "I dati vengono condivisi con:",
  "privacy.section3.items": [
    "Fornitori di servizi di pagamento",
    "Fornitori di spedizione e logistica",
    "Servizi di hosting e infrastruttura"
  ],
  "privacy.section4.title": "4. I Tuoi Diritti",
  "privacy.section4.intro": "In base al GDPR, hai il diritto di:",
  "privacy.section4.items": [
    "Accedere, correggere o cancellare i tuoi dati",
    "Limitare o opporti al trattamento dei dati",
    "Trasferire i tuoi dati a un altro fornitore"
  ],
  "privacy.section4.contact": "Contatto: support@eatorder.com",
  "privacy.section5.title": "5. Cookie",
  "privacy.section5.content": "Utilizziamo cookie per funzionalità essenziali e analisi. Puoi modificare le preferenze dei cookie nel tuo browser.",
  "privacy.section6.title": "6. Sicurezza dei Dati",
  "privacy.section6.content": "Le misure di sicurezza includono crittografia, restrizioni di accesso e backup regolari per proteggere i tuoi dati.",
  "privacy.section7.title": "7. Conservazione dei Dati",
  "privacy.section7.content": "I dati sono conservati per il tempo necessario alla fornitura del servizio e fino a 3 anni dopo la tua ultima attività.",
  "privacy.section8.title": "8. Contatto",
  "privacy.section8.content": "Per domande o dubbi relativi alla privacy, contatta support@eatorder.com.",

  "slogan.main": "Assapora il Momento su EatOrder",
  "slogan.sub": "Ogni morso, un'esperienza di gusto",
  
}
